var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgLock = function SvgLock(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: "1em",
    height: "1em",
    fill: "none",
    viewBox: "0 0 24 24"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#000",
    fillRule: "evenodd",
    d: "M12 2.316a6 6 0 0 1 6 6.001V9.47c.282.062.554.15.816.284a4 4 0 0 1 1.749 1.748c.247.485.345 1.003.391 1.564.045.55.044 1.229.044 2.052v1.4c0 .824.001 1.502-.044 2.052-.046.562-.144 1.08-.392 1.565a4 4 0 0 1-1.748 1.748c-.485.247-1.002.345-1.564.391-.55.045-1.228.044-2.052.044H8.8c-.824 0-1.502.001-2.052-.044-.562-.046-1.08-.144-1.564-.391a4 4 0 0 1-1.748-1.748c-.248-.485-.346-1.003-.392-1.565a14 14 0 0 1-.04-.924L3 16.519v-1.4c0-.824-.001-1.502.044-2.053.046-.561.144-1.079.392-1.564a4 4 0 0 1 1.748-1.748c.262-.134.534-.222.816-.284V8.317a6 6 0 0 1 6-6m0 11.501a1 1 0 0 0-1 1v2a1 1 0 0 0 2 0v-2a1 1 0 0 0-1-1m0-9.5a4 4 0 0 0-4 4V9.32q.375-.002.8-.003h6.4q.426 0 .8.003V8.317a4 4 0 0 0-4-4",
    clipRule: "evenodd"
  })));
};
export default SvgLock;